// extracted by mini-css-extract-plugin
export default {"container":"loading_container__bPVzT","image":"loading_image__Gy8WO","rotation":"loading_rotation__THSkC"};